//#region module
import React from "react";
import PropTypes from "prop-types";
import _, { filter, lte } from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import CubeReqMapper from "../../../utils/CubeReqMapper";
import ReportGraph from "../../../pages/ReportGraph";
import toast from "react-hot-toast";
import {
  Typography, Paper, Stack, FormControl, InputLabel, Grid, Accordion, AccordionSummary, AccordionDetails, FormGroup, FormControlLabel,
  Switch, DialogActions, Select, MenuItem, IconButton, Box, Menu, Fade, Card, Modal, List, ListItem, ClickAwayListener, Button as Mbutton, Popper, Tabs, Tab
} from "@mui/material";
import Limit from "../../common/Limit";
import Button from "../../controls/Button";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Popup from "../../Popup";
import Input from "../../controls/Input";
import { updateReportById } from "../../../config/services/reports";
import SaveIcon from "@mui/icons-material/Save";
import FilterMultipleSelectValue from "../cards/FilterMultipleSelectValue";
import FilterSelectValue from "../cards/FilterSelectValue";
import FilterDateRange from "../cards/FilterDateRange";
import FilterSingleDate from "../cards/FilterSingleDate";

import { LimitAllowedIn } from "../../../constants/chartType";
import { CamelToNormalString, isMobileView } from "../../../utils/Reusables";
import { ReactComponent as FilterIcon } from "../../../assets/icons/icon_filter.svg";
import { ReactComponent as ResizeIcon } from "../../../assets/icons/icon-chart-enlarge.svg";
import { ReactComponent as OrderIcon } from "../../../assets/icons/icon-chart-order.svg";
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import ChartEnlargePopupView from './ChartEnlargePopupView'
import { ReactComponent as CancelIcon } from "../../../assets/icons/icon-cancel.svg";
import { COLORS_SERIES } from '../../../constants/chartColorSeries'
import { ReactComponent as IconAngleDown } from "../../../assets/icons/icon-angle-down.svg"
import { withStyles } from '@mui/styles'
import ReportMenu from "./ReportMenu";
import ReportChartFiltersMenu from "./ReportChartFiltersMenu";
import CloseIcon from "../../../assets/icons/icon_close.svg";
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import ReportServiceTabs from "../../../pages/ChartDashboardV2/ReportServiceTabs";
//import profileReports from "../../../utils/profileSpecificReportsData";
import { handleLanguageChange } from "../../../utils/multiLangDashboardV2Data";
import moment from "moment";
import settings from "../../../config/settings";

import { NumberChartTitleLength, NumberChartDescriptionLength, ReportCardTitleLength, ReportCardDescriptionLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";

const ResponsiveReactGridLayout = WidthProvider(Responsive);
//#endregion

const styles = theme => ({
  tagsContainer: {
    position: '-webkit-sticky',
    position: 'sticky',
    top: 0,
    zIndex: 9,
  },
  tagsList: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
  },
  reportMorePopover: {
    zIndex: '9999'
  },

  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  }
});

const CATEGORY_REPORT_ID = settings?.CATEGORY_REPORT_ID
class DashboardChartLayout extends React.Component {
  constructor(props) {
    super(props);
    let layout = []
    if(props?.selectedReports.length > 0){
      let serviceReportsId = CATEGORY_REPORT_ID
      let serviceReports = props.selectedReports.filter(obj => serviceReportsId.indexOf(obj.reportId) > -1)
      layout = this.generateLayout(serviceReports);
    }
    
    this.state = {
      currentBreakpoint: "lg",
      compactType: "horizontal",
      mounted: false,
      layouts: { lg: props.initialLayout ?? [] },
      selectedReports: props?.selectedReports?.length
        ? props?.selectedReports
        : [],
      isPublishedDashboardView: this.props.isPublishedDashboardView,
      isTitlePopup: {},
      orderByAnchorEl: null,
      currentOrderAnchorEl: null,
      currentOrderElement: '',
      measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports)
        || {},
      dimensionTitle: this.mapDimensionReportsTitle(this?.props?.selectedReports)
        || {},
      enlargeViewObj: {},
      openEnlargeViewPopup: false,
      reportMoreMenuEl: null,
      reportMoreMenuId: null,
      serviceReports: layout,
      serviceReportsFiltered: [],
      currentTab: 0,
      selectedServiceReport: null,
    };
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
  }

  onAccordianChange = (e) => {
    e.stopPropagation()
  }

  onServiceReportSelected = (report) => {
    this.setState({
      selectedServiceReport: report
    });
  }


  componentDidMount() {
    this.setState({ mounted: true });
  }

  componentDidUpdate(prevProps) {
    let { selectedReports, initialLayout, profiles, currentProfile } = this.props;
    //console.log(selectedReports,prevProps.selectedReports,(selectedReports == prevProps.selectedReports))
    if ((selectedReports != prevProps.selectedReports)) {
      //console.log('State Update')
      let serviceReportsId = CATEGORY_REPORT_ID
      let serviceReports = selectedReports.filter(obj => serviceReportsId.indexOf(obj.reportId) > -1)
      const layout = this.generateLayout(serviceReports);
      //console.log(serviceReports)
      this.setState({
        selectedReports: [...selectedReports],
        layouts: { lg: initialLayout },
        measureTitle: this.mapMeasureReportsTitle(this?.props?.selectedReports) || {},
        dimensionTitle: this.mapDimensionReportsTitle(this?.props?.selectedReports) || {},
        profiles: profiles,
        currentProfile: currentProfile,
        serviceReports:layout
      });
    }
  }

  mapMeasureReportsTitle = (data) => {
    //console.log(data)
    let measureTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof measureTitle[_id] !== "object") {
        measureTitle[_id] = {};
      }
      report?.measures?.map((meas) => {
        let { fieldName } = meas;
        measureTitle[_id][fieldName] = meas?.title;
      });
    });
    return measureTitle;
  };

  mapDimensionReportsTitle = (data) => {
    let dimensionTitle = {};
    data?.forEach((report) => {
      let { _id } = report;
      if (typeof dimensionTitle[_id] !== "object") {
        dimensionTitle[_id] = {};
      }
      report?.dimensions?.map((dim) => {
        let { fieldName } = dim;
        dimensionTitle[_id][fieldName] = dim?.title;
      });
    });

    return dimensionTitle;
  };

  handleReportLimit = (e, i) => {
    e.stopPropagation()
    let { value } = e.target;
    if (value < 1) {
      toast.error("Limit cannot be less than 1");
    } else {
      let { selectedReports } = this.props;
      selectedReports[i].limit = value;
      this.setState({ selectedReports: selectedReports });
    }
  };

  handleChangeFilterFromList = (obj, index, e, i) => {
    e.stopPropagation()
    e.target.value =
      typeof e.target.value === "string"
        ? e.target.value.split(",")
        : e.target.value;

    let { selectedReports } = this.props;

    selectedReports[i].reportFilters[index].values = e.target.value;
    this.setState({ selectedReports: selectedReports });
  };

  handleChangeDateFilterFromList = (e, obj, i, dateType, reportIndex) => {
    e.stopPropagation()
    let { selectedReports } = this.props;
    let value = e
    if (moment(value).isValid()) {
      value = moment(value).format("YYYY/MM/DD HH:mm:ss")
    }
    else {
      value = ''
    }
    let newDates = [...obj.values]

    switch (dateType) {
      case 'startDate':
        newDates[0] = value
        break
      case 'endDate':
        newDates[1] = value
        break
      case 'singleDate':
        newDates[0] = value
        break
    }

    selectedReports[reportIndex].reportFilters[i].values = newDates;
    this.setState({ selectedReports: selectedReports });
  };

  getValueListFromCube = (obj) => {
    if (obj.specificValue) return obj.valuesList;

    return [""];
  };

  handleMeasureTitleChange = (e, meas, l, i) => {
    e.stopPropagation()
    const { fieldName } = meas;
    if (typeof this.state.measureTitle[i] !== "object") {
      this.state.measureTitle[i] = {};
    }
    this.state.measureTitle[i][fieldName] = e.target.value;
    this.setState({ measureTitle: this?.state?.measureTitle });
  };

  handleDimensionTitleChange = (e, dim, l, i) => {
    e.stopPropagation()
    const { fieldName } = dim;
    if (typeof this.state.dimensionTitle[i] !== "object") {
      this.state.dimensionTitle[i] = {};
    }
    this.state.dimensionTitle[i][fieldName] = e.target.value;
    this.setState({ dimensionTitle: this?.state?.dimensionTitle });
  };

  handleLegendVisibility = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state.selectedReports);
    let { checked } = e.target;
    selectedReports[i].isLegendVisible = checked;
    this.setState({ selectedReports });
  };

  handleLegendPosition = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state.selectedReports);
    let { value } = e.target;
    selectedReports[i].legendPosition = value;
    this.setState({ selectedReports });
  };

  handleReportLinking = (e, l, i) => {
    e.stopPropagation()
    let selectedReports = Array.from(this.state?.selectedReports);
    let { value } = e?.target;
    const report = selectedReports.find(report => report?.reportName === value)
    selectedReports[i].linkedTo = {
      reportName: value,
      reportId: report?._id
    }
    this.setState({ selectedReports });
  }

  handleSaveTitle = async (e, l, i, index) => {
    e.stopPropagation()
    const measures = l?.measures?.map((meas) => {
      if (this?.state?.measureTitle[i]) {
        let title = this?.state?.measureTitle[i][meas?.fieldName];
        meas.title = title;
        return meas;
      } else {
        return meas;
      }
    });
    l.measures = measures;

    const dimensions = l?.dimensions?.map((dim) => {
      if (this?.state?.dimensionTitle[i]) {
        let title = this?.state?.dimensionTitle[i][dim?.fieldName];
        dim.title = title;
        return dim;
      } else {
        return dim;
      }
    });
    l.dimensions = dimensions;
    let { selectedReports } = this.props;

    selectedReports[index].measures = measures;
    selectedReports[index].dimensions = dimensions;

    this.setState({ selectedReports: selectedReports });

    let params = {
      reportId: selectedReports[index]?.reportId,
      measures: JSON.stringify(selectedReports[index]?.measures),
      dimensions: JSON.stringify(selectedReports[index]?.dimensions),
      isLegendVisible: selectedReports[index]?.isLegendVisible,
      legendPosition: selectedReports[index]?.legendPosition,
      linkedTo: selectedReports[index]?.linkedTo
    };

    return updateReportById(params).then((res) => {
      if (res?.result) {
        toast.success(res.message);
        this.toggleTitlePopup(e, false, i);
      } else if (res?.data?.statusCode === 0) {
        toast.error(res?.data?.error?.errorMessage);
      } else {
        console.error(res);
      }
    });
  };
  handleCLoseTitlePopup = (e, i) => {
    e.stopPropagation()
    const measureTitle = this.mapMeasureReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapMeasureReportsTitle(this?.props?.selectedReports)
      : {};
    const dimensionTitle = this.mapDimensionReportsTitle(
      this?.props?.selectedReports
    )
      ? this.mapDimensionReportsTitle(this?.props?.selectedReports)
      : {};
    this.setState({
      measureTitle: measureTitle,
      dimensionTitle: dimensionTitle,
    });
    this.toggleTitlePopup(e, false, i);
  };

  enlargeChart = (chartData) => {
    this.setState({ enlargeViewObj: chartData, openEnlargeViewPopup: true })
  }

  handleCloseEnlargeView = () => {
    this.setState({ openEnlargeViewPopup: false, enlargeViewObj: {} })
  }

  handleReportMoreMenuClick = (e, i) => {
    e.preventDefault();
    if (e.target != this.state.reportMoreMenuEl) {
      this.setState({
        reportMoreMenuId: i,
        reportMoreMenuEl: e.target,
      });
    } else {
      this.handleReportMoreMenuClose();
    }

  };

  handleReportMoreMenuClose = () => {
    this.setState({
      reportMoreMenuId: null,
      reportMoreMenuEl: null,
    });
  };

  updateReportDetails = (selectedReports) => {
    this.setState({ selectedReports: selectedReports });
  }


  generateFilterMenu = (filters, reportIndex) => {
    let Menus = []
    const reportDetails = this.props?.selectedReports

    filters.map((obj, index) => {
      let { listType, operator, displayName } = obj
      let propObj = {
        i: index,
        reportIndex,
        filterCondtion: obj,
        handleChangeFilterFromList: this.handleChangeFilterFromList,
        reportDetails: reportDetails,
        from: 'dashboard',
        updateReportDetails: this.updateReportDetails
      }

      let dateFilterProps = {
        i: index,
        reportIndex,
        obj,
        handleDateFilter: this.handleChangeDateFilterFromList,
      }

      if (listType && operator === "equals") {
        Menus.push({
          label: (
            <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
              <InputLabel size='small'> {displayName} </InputLabel>
              {listType === "dropdown" ? <FilterSelectValue {...propObj} /> : <FilterMultipleSelectValue {...propObj} />}
            </FormControl>
          ),
          func: () => { }
        })
      }
      else if (operator === "inDateRange" || operator === "notInDateRange") {
        Menus.push({
          label: (<FilterDateRange {...dateFilterProps} />),
          func: () => { }
        })
      }
      else if (operator === "beforeDate" || operator === "afterDate") {
        Menus.push({
          label: (<FilterSingleDate {...dateFilterProps} />),
          func: () => { }
        })
      }
      else {
        Menus.push(null)
      }
    })

    return Menus
  }

  handleReportClick = (e, report, index) => {
    e.stopPropagation()
    if (report && report?.linkedTo) {
      let eleCard = document.querySelector(`#report-${report?.linkedTo?.reportId}`);

      if (eleCard) {
        eleCard.classList.add('dash-report-highlight');
        eleCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          eleCard.classList.remove('dash-report-highlight');
        }, 5000)
      }
    }
  }

  handleOrderBy = (order) => {
    this.handleOrderByEleClose()
    let { report, index, type } = this.state.selectedOrderByReport;
    let currentOrderEl = this.state.currentOrderElement;
    let orderObj = {};
    orderObj[currentOrderEl] = order

    for (let ob in report.orderBy) {
      if (ob !== currentOrderEl) {
        orderObj[ob] = report.orderBy[ob]
      }
    }
    report.orderBy = orderObj

    if (type === 'service_reports') {
      let { selectedReports } = this.props;
      let serviceReport = this.state.serviceReports
      for (let service = 0; service < serviceReport.length; service++) {
        if (serviceReport[service]._id === report?._id) {
          serviceReport[service] = report;
          selectedReports[service] = report;
          break;
        }
      }

      this.setState({
        selectedReports: selectedReports,
        serviceReports: serviceReport,
      })

    }
    else {

      let { selectedReports } = this.props;
      let serviceFReports = Array.from(this.state.serviceReportsFiltered)
      if (serviceFReports?.length) {
        for (let filtered = 0; filtered < serviceFReports.length; filtered++) {
          if (serviceFReports[filtered]?._id === report?._id) {
            serviceFReports[filtered] = report
            break;
          }
        }

      }

      selectedReports[index] = report
      this.setState({
        selectedReports: selectedReports, serviceReportsFiltered: serviceFReports
      });

    }
  }

  getItemDisplayName = (itemText, reportDetails) => {
    const measures = reportDetails?.measures;
    const dimensions = reportDetails?.dimensions;
    let displayName;

    for (let dim of dimensions) {
      if (dim?.fieldName.split('.')[1] === itemText) {
        displayName = dim?.displayName;
        break;
      }
    }
    if (!displayName) {
      for (let meas of measures) {
        if (meas?.fieldName.split('.')[1] === itemText) {
          displayName = meas?.displayName;
          break;
        }
      }
    }
    return displayName ? displayName : itemText
  }




  generateDOM = () => {
    let { selectedReports, dimensionTitle, measureTitle, isTitlePopup } = this.state;
    const layout = this.generateLayout(selectedReports);
    const { classes,studentId } = this.props;
    const styles = {
      border: '1px solid #dedede',
      p: 1,
      backgroundColor: '#fff',
      borderRadius: '4px',
    };

    let reportIds = []
    const learningProfileMapping = this.props.learningProfileMapping
    const selectedProfile = this.props.selectedProfile
    //console.log(selectedReports)
    let learningProf = []
    if (learningProfileMapping.length && selectedProfile && selectedProfile?.length) {
      learningProfileMapping.forEach(prof => {
        const exist = selectedProfile.find(p => p?.profile === prof?.profileName)
        if (exist) {
          if (learningProf?.length) {
            if (!learningProf.find(p => p && p?.profile === exist?.profile))
              learningProf.push({ profile: prof?.learningProfile })
          }
          else {
            learningProf.push({ profile: prof?.learningProfile })
          }
        }
      })
    }

    if (learningProf.length && selectedProfile && selectedProfile.length) {
      reportIds = []
      for (let selected of learningProf) {
        for (let prof of settings.profileReports) {
          if (prof?.profileName && prof?.profileName.includes(selected?.profile)) {
            reportIds.push(...prof?.reportId)
          }
        }
      }
    }

    var filteredArray = [];
    //console.log(layout,this.state.serviceReports,this.state.serviceReportsFiltered)
    if (this.state.serviceReportsFiltered?.length == 0) {
      let serviceReportsId = CATEGORY_REPORT_ID

      filteredArray = _.filter(layout, _.bind(function (obj) {
        if (serviceReportsId.includes(obj._id)) {
          if (reportIds.length) {
            //this.state.serviceReports = [];
            for (let id of reportIds) {
              if (id === serviceReportsId[0] || id === serviceReportsId[1] || id === serviceReportsId[2] || id === serviceReportsId[3]) {
                //this.state.serviceReports.push(obj);
              }
            }
          }
          else {
            //this.state.serviceReports.push(obj);
          }
          return false;
        }
        return true;
      }, this));
      this.setState({
        serviceReportsFiltered: filteredArray
      })
    }
    //console.log(this.state.serviceReportsFiltered)
    return _.map(this.state.serviceReportsFiltered, (report, i) => {
      let l = selectedReports.find(obj => obj.reportId == report.reportId)
      //console.log(l)
      if (reportIds.length) {
        if (reportIds && reportIds.length && reportIds.includes(l?._id)) {
          if (l.chartType === 'number') {
            return (
              <Grid key={l.i} item xs={12} sm={12} md={6} lg={6} className="er-report-grid report-number" >
                <Card id={`report-${l?._id}`} onClick={e => this.handleReportClick(e, l, l.i)} data-grid={l} variant="outlined"
                  className="er-chart-number-card" style={{ background: COLORS_SERIES[(i % COLORS_SERIES.length)] }}
                >
                  <Box sx={{}}>
                    <Typography className="er-chart-title text-center" variant="h6">{handleLanguageChange(l.reportName)}</Typography>
                    {l._id && (
                      <ReportGraph
                        reportDetails={
                          CubeReqMapper(
                            l,
                            [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }],
                            true,
                            true,
                            { studentId: studentId })
                        }
                        openToolBar={false}
                      />)}
                    <Typography className="er-chart-subtitle" variant="p">{handleLanguageChange(l.description)}</Typography>
                  </Box>
                </Card>
              </Grid>
            )
          }

          return (
            <Grid key={l.i} item xs={12} sm={12} md={6} lg={6} className="min-height-300" >
              <div data-grid={l} onClick={e => this.handleReportClick(e, l, l.i)} className="er-chart-box" id={`report-${l?._id}`} >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  spacing={2}
                  className="grid_drag"
                >
                  <Box>
                    <Grid container >
                      <Grid item xs={12} className="er-chart-box-heading">
                        <Typography variant="h4" className="er-chart-title" title={handleLanguageChange(l?.reportName)}
                          > {handleStringLength(handleLanguageChange(l?.reportName), ReportCardTitleLength)} </Typography>
                        <Typography variant="p" className="er-chart-subtitle" title={handleLanguageChange(l?.description)}
                          > {handleStringLength(handleLanguageChange(l?.description), ReportCardDescriptionLength)} </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  <Box className="grid_header_icons">
                    {/* {
                      (l.chartType === 'bar') ?
                        <>
                          <IconButton className="form-icon-btn" onClick={(e) => this.handleOrderByDrop(l, i, e)} >
                            <OrderIcon />
                          </IconButton>
                        </>
                        : null

                    } */}
                    {isMobileView() ? null :
                      <IconButton className="form-icon-btn" onClick={() => this.enlargeChart(l)} >
                        <ResizeIcon />
                      </IconButton>}


                  </Box>
                </Stack>

                <Stack className="grid_drag inherit-height" sx={{ pt: '1.25rem' }}>
                  {l._id && (
                    <ReportGraph reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], true,true,{studentId:studentId})} openToolBar={false} />
                  )}
                </Stack>


              </div>
            </Grid>
          );
        }
      }
      else {
        if (l.chartType === 'number') {
          return (
            <Grid key={l.i} item xs={12} sm={12} md={6} lg={6} className="er-report-grid report-number" >
              <Card id={`report-${l?._id}`} onClick={e => this.handleReportClick(e, l, l.i)} data-grid={l} variant="outlined"
                className="er-chart-number-card" style={{ background: COLORS_SERIES[(i % COLORS_SERIES.length)] }}
              >
                <Box sx={{}}>
                  <Typography variant="h6" className="text-center">{handleLanguageChange(l.reportName)}</Typography>
                  {l._id && (<ReportGraph reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], true, true,{studentId:studentId})} openToolBar={false} />)}
                  <Typography variant="p">{handleLanguageChange(l.description)}</Typography>
                </Box>
              </Card>
            </Grid>
          )
        }

        return (
          <Grid key={l.i} item xs={12} sm={12} md={6} lg={6} className="er-report-grid" >
            <div data-grid={l} onClick={e => this.handleReportClick(e, l, l.i)} className="er-chart-box" id={`report-${l?._id}`} >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                spacing={2}
                className="grid_drag"
              >
                <Box>
                  <Grid container mb={2} >
                    <Grid item xs={12} className="er-chart-box-heading">
                      <Typography variant="h4" className="er-chart-title" title={handleLanguageChange(l?.reportName)}
                        > {handleStringLength(handleLanguageChange(l?.reportName), ReportCardTitleLength)} </Typography>
                      <Typography variant="p" className="er-chart-subtitle" title={handleLanguageChange(l?.description)}
                        > {handleStringLength(handleLanguageChange(l?.description), ReportCardDescriptionLength)} </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box className="grid_header_icons">
                  {/* {
                    (l.chartType === 'bar') ?
                      <>
                        <IconButton className="form-icon-btn" onClick={(e) => this.handleOrderByDrop(l, i, e)} >
                          <OrderIcon />
                        </IconButton>
                      </>
                      : null

                  } */}

                  {isMobileView() ? null :
                    <IconButton className="form-icon-btn" onClick={() => this.enlargeChart(l)} >
                      <ResizeIcon />
                    </IconButton>}
                </Box>
              </Stack>

              <Stack className="grid_drag inherit-height" sx={{ pt: '1.25rem' }}>
                {l._id && (
                  <ReportGraph reportDetails={CubeReqMapper(l, [{ ...measureTitle[l?._id], ...dimensionTitle[l?._id] }], true, true,{studentId:studentId})} openToolBar={false} />
                )}
              </Stack>


            </div>
          </Grid>
        );
      }

    });

  };

  onServiceReportSelected = (report) => {
    this.setState({
      selectedServiceReport: report
    });
  }
  handleOrderByDrop = (report, index, event, type) => {
    this.setState({
      selectedOrderByReport: { report: report, index: index, type: type }, orderByAnchorEl: event.currentTarget
    })
  }

  handlePopupOrderByDrop = (report, index, event, type) => {
    this.setState({
      selectedOrderByReport: { report: report, index: index, type: type }
    })
  }

  generateServiceReports = (reports) => {
    //console.log('Service Reports', reports)
    let { dimensionTitle, measureTitle } = this.state;
    let serviceReports = _.uniq(reports);
    const layout = this.generateLayout(serviceReports);
    return (
      <Grid item xs={12} sm={12} md={12} lg={12} className="er-report-grid" >
        <div className="er-chart-box er-chart-services"  >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={2}
            className="grid_drag er-chart-box-heading"
          >
            <Box>
              <Grid container mb={2} >
                <Grid item xs={12} className="">
                  <Typography variant="h4" className="er-chart-title"> {handleLanguageChange("Category Analysis")} </Typography>
                  <Typography variant="p" className="er-chart-subtitle"> {handleLanguageChange('Monitor your performance in different categories with respect to L, P & T')} </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box className="grid_header_icons">
              {/* <IconButton className="form-icon-btn" onClick={(e) => this.handleOrderByDrop((this.state.selectedServiceReport != null) ? this.state.selectedServiceReport : this.state.serviceReports[0], undefined, e, "service_reports")} >
                <OrderIcon />
              </IconButton> */}
              {isMobileView() ? null :
                <IconButton className="form-icon-btn" onClick={() => this.enlargeChart((this.state.selectedServiceReport != null) ? this.state.selectedServiceReport : this.state.serviceReports[0])} >
                  <ResizeIcon />
                </IconButton>}
            </Box>
          </Stack>

          <ReportServiceTabs selectedReports={this.state.serviceReports} measureTitle={this.state.measureTitle} dimensionTitle={this.state.dimensionTitle} onTabSelected={this.onServiceReportSelected} selectedProfile={this.props.selectedProfile} learningProfileMapping={this.props.learningProfileMapping} studentId={this.props?.studentId} />
        </div>
      </Grid>
    );


  };




  toggleTitlePopup = (e, params, i) => {
    this.state.isTitlePopup[i] = params;
    this.setState({ isTitlePopup: this.state?.isTitlePopup });
  };

  onBreakpointChange = (breakpoint) => {
    this.setState({
      currentBreakpoint: breakpoint,
    });
  };

  onLayoutChange = (layout, layouts) => {
    this.props.onLayoutChange(layout, layouts);
    this.setState({ layouts: layouts });
  };

  onNewLayout = () => {
    let { selectedReports } = this.state;
    this.setState({
      layouts: { lg: this.generateLayout(this.state.selectedReports) },
    });
  };

  handleOrderByClose = () => {
    this.setState({ orderByAnchorEl: null })
  }

  handleOrderByEleClose = () => {
    this.setState({ currentOrderAnchorEl: null })
  }

  handleOrderByDisplayName = (report, order) => {
    const { measures, dimensions } = report;
    if (measures.length) {

    }
  }

  handleOrderEleClick = (event, order) => {
    this.setState({
      currentOrderElement: order,
      currentOrderAnchorEl: event.currentTarget
    })
  }
  handlePopupOrderEleClick = (order) => {
    this.setState({
      currentOrderElement: order,
    })
  }


  generateLayout = (selectedReports) => {
    let newSelectedReports = [...selectedReports];
    let newLayout = _.map(newSelectedReports, (item, i) => {
      const minW = _.random(1, 6);
      const minH = _.random(1, 6);
      const maxW = _.random(minW, 6);
      const maxH = _.random(minH, 6);
      const y = _.random(minH, maxH);

      let result = {
        ...item,
        x: item.x || item.x === 0 ? item.x : (i * 2) % 12,
        y: item.y || item.y === 0 ? item.y : Math.floor(i / 6) * y,
        w: item.w ? item.w : 6,
        h: item.h ? item.h : 2,
        i: item.i ? item.i : item._id.toString(),
      };
      return result;
    });
    return newLayout;
  };

  render() {
    let { isPublishedDashboardView, openEnlargeViewPopup, enlargeViewObj, measureTitle, dimensionTitle, selectedReports, selectedOrderByReport, currentOrderElement } = this.state;
    let { handleSelectReport, currentProfile, profiles, studentId } = this.props
    const { classes } = this.props;

    return (
      <>

        <Box className="er-chart-grid charts" id="dashboardWrapper" sx={{ flexGrow: 1 }} >
          <Grid container spacing={2} >
            {this.generateDOM()}
            {this.generateServiceReports(this.state.serviceReports)}
          </Grid>
          {openEnlargeViewPopup ? <ChartEnlargePopupView currentOrderElement={currentOrderElement} handleOrderBy={this.handleOrderBy} 
            getItemDisplayName={this.getItemDisplayName} selectedOrderByReport={selectedOrderByReport} 
            handleOrderEleClick={this.handlePopupOrderEleClick} chartObj={enlargeViewObj} handleOrderByDrop={this.handlePopupOrderByDrop} 
            reportName={enlargeViewObj?.reportName} openPopup={openEnlargeViewPopup} handleClose={this.handleCloseEnlargeView} 
            ChartComponent={enlargeViewObj._id && (
            <ReportGraph
              reportDetails={CubeReqMapper(enlargeViewObj, [
                { ...measureTitle[enlargeViewObj?._id], ...dimensionTitle[enlargeViewObj?._id], }
              ], true,true,{studentId:studentId})}
              openToolBar={false}
            />
          )} /> : null}
        </Box>

        <Menu
          id="simple-menu"
          anchorEl={this.state.orderByAnchorEl}
          keepMounted
          open={Boolean(this.state.orderByAnchorEl)}
          onClose={this.handleOrderByClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          {
            selectedOrderByReport && selectedOrderByReport?.report?.orderBy && Object.keys(selectedOrderByReport?.report?.orderBy).map((order, index) => (
              <MenuItem key={index} onClick={e => this.handleOrderEleClick(e, order)} className="text-plain font-weight-500">{this.getItemDisplayName(order, selectedOrderByReport?.report)}</MenuItem>

            ))
          }

        </Menu>



        <Menu
          id="simple-menu"
          anchorEl={this.state.currentOrderAnchorEl}
          keepMounted
          open={Boolean(this.state.currentOrderAnchorEl)}
          onClose={this.handleOrderByEleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={e => this.handleOrderBy('asc')} className={selectedOrderByReport?.report?.orderBy[currentOrderElement] === 'asc' && 'visualize_list_text'}>Asc</MenuItem>
          <MenuItem onClick={e => this.handleOrderBy('desc')} className={selectedOrderByReport?.report?.orderBy[currentOrderElement] === 'desc' && 'visualize_list_text'}>Desc</MenuItem>

        </Menu>

      </>
    );


  }
}



DashboardChartLayout.propTypes = {
  onLayoutChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};
DashboardChartLayout.defaultProps = {
  rowHeight: 200,
  onLayoutChange: function () { },
  cols: { lg: 12, md: 8, sm: 4, xs: 1, xxs: 1 },
  // breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }
  // initialLayout: generateLayout(),
};

export default withStyles(styles)(DashboardChartLayout);
